export enum ProjectDeploymentStatus {
  Deployed = 'Deployed',
  NotDeployed = 'Not Deployed',
}
